const JUMP_VEL = 1400;
const GRAVITY = 3000;

const STATE_WAIT = 0;
const STATE_ENTER = 1;
const STATE_RUN = 2;
const STATE_EXIT = 3;
const STATE_GO_BACK = 4;

export default class Hero extends Phaser.Group {
  constructor(game, levelRef, x, y, charData, levelHeight) {
    super(game);

    //
    this.ANIM_RUN = 'run';
    this.ANIM_JUMP = 'jump';

    this.SIZES = {
      jump: { dx: 0, dy: -100, rect: { x: -45, y: -170, w: 90, h: 170 } },
      run: { dx: 0, dy: 0, rect: { x: -45, y: -170, w: 90, h: 170 } },
    };

    this.m_posX0 = x;
    this.m_posX = -600;
    this.m_posY = y;
    this.m_levelHeight = levelHeight;
    this.levelRef = levelRef;
    this.rect = new Phaser.Rectangle();

    this.positions = [];

    this.groundY = y;
    this.depth = charData.depth;

    this.m_animId = '';

    this.m_asset = this.game.make.sprite(0, 0, 'chasegame_char_' + charData.id);
    this.m_asset.anchor.set(0.5, 1);

    let lastFrame = charData.id == 'scooby' ? 8 : 16;
    let frames = Phaser.Animation.generateFrameNames('run_', 1, lastFrame, '', 4);
    this.m_asset.animations.add('run', frames, 24, true, false);
    this.m_asset.animations.add('jump', ['jump_0001', 'jump_0002'], 24, false, false);
    this.m_asset.animations.add('fall', ['jump_0003', 'jump_0004'], 24, false, false);
    this.addChild(this.m_asset);

    this.reset();

    this.setAnim(this.ANIM_RUN);

    this.game.sounds.playSpriteSFX('running', {
      spriteID: 'game_audiosprite',
      loop: true,
      volume: 0.7,
    });
  }

  isRunning() {
    return this.state == STATE_RUN;
  }

  isGoingBack() {
    return this.state == STATE_GO_BACK;
  }

  destroy() {
    this.m_asset.animations.stop();
    this.m_asset = null;
    super.destroy();
  }

  reset() {
    this.m_speedX = 500;
    this.m_speedY = 0;
    this.m_speedXDest = 500;
    this.m_onGround = false;
    this.m_releasedActionA = true;
    this.m_releasedActionB = true;
    this.m_started = false;
    this.m_groundCounter = 0;
    this.m_moveBackCounter = 0;
    this.onPositionToCatch = true;

    this.state = STATE_ENTER;
  }

  start() {
    if (!this.m_started) {
      this.m_started = true;
      this.setAnim(this.ANIM_RUN);
    }
  }

  pause() {
    this.m_asset.animations.paused = true;
  }

  resume() {
    this.m_asset.animations.paused = false;
  }

  exit() {
    this.state = STATE_EXIT;
  }

  goBack() {
    this.state = STATE_GO_BACK;
  }

  setAnim(animId) {
    if (this.m_animId != animId) {
      this.m_animId = animId;
      this.m_asset.play(animId);
      this.m_size = this.SIZES[animId];

      this.x = this.m_posX + this.m_size.dx;
      this.y = this.m_levelHeight - this.m_posY + this.m_size.dy;

      // if (animId == this.ANIM_RUN) {
      //   this.game.sounds.playSpriteSFX('running', {
      //     spriteID: 'game_audiosprite',
      //     ignoreIfPlaying: true,
      //     volume: 1,
      //   });
      // }
    }
  }

  step(dt) {
    if (this.m_started) {
      // increase speed
      // if (this.m_speedXDest < 700) {
      //   this.m_speedXDest += 10 * dt;
      // } else {
      //   this.m_speedXDest = 700;
      // }
      this.m_speedXDest = this.villainRef.m_speedX;

      //
      this.m_speedX += (this.m_speedXDest - this.m_speedX) * 2 * dt;

      // enter the screen
      if (this.state == STATE_ENTER) {
        this.m_posX += this.m_speedX * dt;
        if (this.m_posX > this.m_posX0) {
          this.m_posX = this.m_posX0;
          this.state = STATE_RUN;
        }
      } else if (this.state == STATE_EXIT) {
        this.m_posX += this.m_speedX * dt;
        if (this.m_posX > this.game.width + 700) {
          this.state = STATE_WAIT;
          this.levelRef.gameOver(true);
        }
      } else if (this.state == STATE_GO_BACK) {
        this.m_posX -= 140 * dt;
        if (this.m_posX < -200) {
          this.state = STATE_WAIT;
          this.levelRef.gameOver(false);
        }
      }
    }

    //gravity
    if (this.m_speedY > -1000) {
      this.m_speedY -= GRAVITY * dt;
    }

    // check ground
    this.m_posY += this.m_speedY * dt;
    if (this.m_posY < this.groundY) {
      this.m_posY = this.groundY;
      this.m_onGround = true;
      this.m_groundCounter = 1;
      this.m_speedY = 0;

      if (this.m_started) {
        if (this.m_animId != this.ANIM_TRIP) {
          this.setAnim(this.ANIM_RUN);
        }
      }
    }

    //move back and forward on trip
    if (this.state == STATE_RUN) {
      if (this.m_moveBackCounter > 0) {
        this.m_moveBackCounter -= dt;
        if (this.m_moveBackCounter <= 0) {
          this.m_moveBackCounter = 0;
          this.m_stayBackCounter = 1;
        }
        this.m_posX = this.m_posX1 - (1 - this.m_moveBackCounter) * 140;
        this.m_posX = Math.max(-100, this.m_posX);
        if (this.m_posX < 50) {
          // game lost
          this.levelRef.gameLost();
        }
      } else if (this.m_stayBackCounter > 0) {
        this.m_stayBackCounter -= dt;
        if (this.m_stayBackCounter <= 0) {
          this.m_stayBackCounter = 0;
          this.m_moveForwardCounter = 4;
          this.m_posX2 = this.m_posX;
        }
      } else if (this.m_moveForwardCounter > 0) {
        this.m_moveForwardCounter -= dt;
        if (this.m_moveForwardCounter <= 0) {
          this.m_moveForwardCounter = 0;
          this.onPositionToCatch = true;
        }
        this.m_posX =
          this.m_posX2 + (1 - this.m_moveForwardCounter / 4) * (this.m_posX0 - this.m_posX2);
      }
    }

    //
    if (this.m_started && !this.m_onGround && this.m_groundCounter-- == 0) {
      this.setAnim(this.ANIM_JUMP);
    }

    //
    this.stepFlash(dt);

    //
    this.x = this.m_posX;
    this.y = this.m_levelHeight - this.m_posY + this.m_size.dy;

    // shadow
    let factor = 1 - Math.min(1, Math.abs((this.m_posY - this.groundY) / 200));
    this.shadow.scale.set(factor);
    this.shadow.alpha = factor;
    this.shadow.x = this.x;

    //
    if (this.m_posY > this.groundY) {
      this.m_onGround = false;
    }

    //
    this.savePosition();
  }

  savePosition() {
    let pos = {
      x: this.x,
      y: this.y,
      anim: this.m_animId,
      t: this.game.time.time,
      speed: this.m_speedX,
      alpha: this.alpha,
    };

    this.positions.push(pos);
    this.positions = this.positions.filter((p) => p.t > pos.t - 500);
  }

  stepFlash(dt) {
    if (this.flashTime > 0) {
      this.flashTime -= dt;
      let frame = (this.flashTime * 30) | 0;
      if (frame > 8) {
        this.alpha = frame % 4 < 2 ? 1 : 0;
      } else {
        this.alpha = frame % 2;
      }
      if (this.flashTime <= 0) {
        this.alpha = 1;
      }
    }
  }

  getRect() {
    this.rect.x = this.x + this.m_size.rect.x;
    this.rect.y = this.y + this.m_size.rect.y;
    this.rect.width = this.m_size.rect.w;
    this.rect.height = this.m_size.rect.h;
    return this.rect;
  }

  onHitBlock(block, rectH, rectB, dt) {
    //check left side of block
    if (rectH.x <= rectB.x) {
      if (this.m_speedY > 0) {
        block.wasHit = true;
        this.onHitObstacle();
        return;
      } else {
        //check collission with left side when falling down
        var dy = rectH.y + rectH.height - rectB.y; // distance between feet and block top
        if (rectH.y > rectB.y) {
          block.wasHit = true;
          this.onHitObstacle();
          return;
        } else if (dy > 0 && dy > -this.m_speedY * dt + 5) {
          block.wasHit = true;
          this.onHitObstacle();
          return;
        }
      }
    }

    //no collission - place hero on top
    var hx = rectH.x + rectH.width * 0.5;
    if (hx > rectB.x && hx < rectB.x + rectB.width) {
      this.m_posY = this.m_levelHeight - block.rect.y;
      this.m_onGround = true;
      this.m_groundCounter = 1;

      this.setAnim(this.ANIM_RUN);

      this.m_speedY = 0;

      this.y = this.m_levelHeight - this.m_posY + this.m_size.dy;
    }
  }

  actionA() {
    if (
      this.m_started &&
      this.m_releasedActionA &&
      this.m_onGround &&
      this.m_animId != this.ANIM_TRIP
    ) {
      //jump
      this.m_releasedActionA = false;
      this.m_speedY = JUMP_VEL;
      this.setAnim(this.ANIM_JUMP);
      //this.game.sounds.playAudio('jump', 0.3);

      //this.game.sounds.stopSFX('running', { spriteID: 'game_audiosprite' });
      this.game.sounds.playSpriteSFX('jump', { spriteID: 'game_audiosprite' });
    }
  }

  releaseActionA() {
    this.m_releasedActionA = true;
  }

  onHitObstacle() {
    // this.setAnim(this.ANIM_TRIP);

    this.flashTime = 0.8;

    var me = this;

    this.onPositionToCatch = false;

    this.m_moveBackCounter = 1;
    this.m_posX1 = this.m_posX;
    this.m_speedXDest -= 40;
    this.m_speedXDest = Math.max(400, this.m_speedXDest);
    this.m_speedX -= 40;
    this.m_speedX = Math.max(400, this.m_speedX);
  }

  onTripAnimEnd() {
    this.setAnim(this.ANIM_RUN);
  }

  getNormalizedY() {
    return Math.min(1, 1 - this.m_posY / this.m_levelHeight);
  }

  destroy() {
    this.game.sounds.stopSFX('running', { spriteID: 'game_audiosprite' });

    super.destroy();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/objects/Hero.js